export const MAX_ACCOUNT_SETS = 8;

export const DEFAULT_OPTIONAL_RECOMMENDATION_COUNT = 2;

export enum AccountSetRowKind {
  CURRENT = 'current',
  RECOMMENDED = 'recommended',
  RECOMMENDED_OPTIONAL = 'recommendedOptional',
}
